import { cx } from '@emotion/css';
import { ReactNode } from 'react';

import {
  Button,
  ButtonLink,
  ButtonLinkProps,
  ButtonProps,
} from 'apps/shared/scripts/components';

import {
  buttonClassName,
  mobileClassName,
  mobileIconClassName,
  mobileTextClassName,
} from './styles';

interface OwnProps {
  className?: string;
  children?: ReactNode;
  link?: boolean;
  mobile?: boolean;
}

type Props = (ButtonProps | ButtonLinkProps) & OwnProps;

const Cta = ({
  className,
  children,
  link,
  textClassName,
  mobile,
  ...props
}: Props) => {
  if (link) {
    return (
      <ButtonLink
        className={cx(
          buttonClassName,
          {
            [mobileClassName]: mobile,
          },
          className,
        )}
        iconClassName={cx({ [mobileIconClassName]: mobile })}
        textClassName={cx(textClassName, {
          [mobileTextClassName]: mobile,
        })}
        {...(props as ButtonLinkProps)}
        subtle
      >
        {children}
      </ButtonLink>
    );
  }

  return (
    <Button
      className={cx(
        buttonClassName,
        {
          [mobileClassName]: mobile,
        },
        className,
      )}
      iconClassName={cx({ [mobileIconClassName]: mobile })}
      textClassName={cx(textClassName, {
        [mobileTextClassName]: mobile,
      })}
      {...(props as ButtonProps)}
      subtle
    >
      {children}
    </Button>
  );
};

Cta.displayName = 'Cta';

export default Cta;
